// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sponsored-recommendation[data-v-65dfd41b]{grid-area:double-poster;height:100%}@media(max-width:540px){.sponsored-recommendation .sponsored-recommendation__view[data-v-65dfd41b]{height:255px;min-width:370px}}.sponsored-recommendation__list[data-v-65dfd41b]{width:370px}@media(max-width:768px){.sponsored-recommendation__list[data-v-65dfd41b]{height:255px;min-width:350px;max-width:370px}}", ""]);
// Exports
module.exports = exports;
